/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SimulatorDisplay_imageResult = {
    readonly uuid: string;
    readonly identifiedStatus: string;
    readonly image: {
        readonly normal: {
            readonly images: {
                readonly topURL: string;
                readonly sideURL: string;
            };
        };
        readonly threat: {
            readonly threatXray: {
                readonly images: {
                    readonly topURL: string;
                    readonly sideURL: string;
                };
            };
            readonly topPosition: {
                readonly x: number;
                readonly y: number;
                readonly scale: number;
                readonly rotation: number;
            };
            readonly sidePosition: {
                readonly x: number;
                readonly y: number;
                readonly scale: number;
                readonly rotation: number;
            };
        } | null;
    };
    readonly " $refType": "SimulatorDisplay_imageResult";
};
export type SimulatorDisplay_imageResult$data = SimulatorDisplay_imageResult;
export type SimulatorDisplay_imageResult$key = {
    readonly " $data"?: SimulatorDisplay_imageResult$data;
    readonly " $fragmentRefs": FragmentRefs<"SimulatorDisplay_imageResult">;
};



const node: ReaderFragment = (function () {
    var v0 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "images",
            "storageKey": null,
            "args": null,
            "concreteType": "ImageURLs",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "topURL",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "sideURL",
                    "args": null,
                    "storageKey": null
                }
            ]
        } as any)
    ], v1 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "x",
            "args": null,
            "storageKey": null
        } as any),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "y",
            "args": null,
            "storageKey": null
        } as any),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "scale",
            "args": null,
            "storageKey": null
        } as any),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "rotation",
            "args": null,
            "storageKey": null
        } as any)
    ];
    return {
        "kind": "Fragment",
        "name": "SimulatorDisplay_imageResult",
        "type": "ImageResult",
        "metadata": null,
        "argumentDefinitions": [],
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "uuid",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "identifiedStatus",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "image",
                "storageKey": null,
                "args": null,
                "concreteType": "PackagedImage",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "normal",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "NormalXray",
                        "plural": false,
                        "selections": (v0 /*: any*/)
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "threat",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ThreatBundle",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "threatXray",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "ThreatXray",
                                "plural": false,
                                "selections": (v0 /*: any*/)
                            },
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "topPosition",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "ThreatPosition",
                                "plural": false,
                                "selections": (v1 /*: any*/)
                            },
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "sidePosition",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "ThreatPosition",
                                "plural": false,
                                "selections": (v1 /*: any*/)
                            }
                        ]
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = '1f55283b234e3de72fe045bbf7bd2cad';
export default node;
